import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function HeroSection() {
  return <section data-section-id="252589" id="hero-section" className="bg-background text-foreground py-16 md:py-24 lg:py-32 relative overflow-hidden bg-gradient-to-br from-background to-accent/30">
      <div className="page-container relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="flex flex-col items-start gap-6">
            <h1 className="font-default text-4xl md:text-5xl lg:text-[48px] font-bold leading-tight text-primary">
              Comunicación Unificada con Microsoft Teams
            </h1>
            <p className="text-lg md:text-[18px] text-muted-foreground max-w-xl font-sans">Optimice la colaboración de su equipo integrando todas sus herramientas de comunicación en una sola plataforma. Conecte, colabore y crezca con soluciones de telefonía IP y chat empresarial. Con el respaldo de un software Alemán Homologado por Microsoft - Solo en Avtec 2263-3278</p>
            <div className="flex flex-wrap gap-4 mt-4">
              <Button asChild size="lg" className="font-bold text-base rounded-md bg-primary text-primary-foreground shadow-md transition-all hover:shadow-lg">
                <Link to="/OmnichannelPage">
                  <SafeHydrate><Calendar className="w-5 h-5 mr-2" /></SafeHydrate>
                  Solicitar Demostración
                </Link>
              </Button>
            </div>
          </div>
          <div className="relative w-full rounded-lg overflow-hidden shadow-xl">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/ms_teams_integration_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/ms_teams_integration_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/ms_teams_integration_hero.png-wvc-sizes" alt="Integración de Microsoft Teams para empresas" className="w-full h-auto object-cover aspect-[4/3] rounded-lg" loading="lazy" src="https://avtecsa.com/wp-content/uploads/2026/05/teams.png" />
          </div>
        </div>
      </div>
    </section>;
}